import { clearAuthData } from './authStorage';

/**
 * Logout handler that can be used anywhere in the app
 *
 * Usage:
 * ```typescript
 * import { useAuth0 } from '@auth0/auth0-react';
 * import { handleLogout } from '@lucid/auth';
 *
 * const MyComponent = () => {
 *   const { logout } = useAuth0();
 *
 *   return (
 *     <button onClick={() => handleLogout(logout)}>
 *       Logout
 *     </button>
 *   );
 * };
 * ```
 */
export const handleLogout = (
  auth0Logout: (options?: { logoutParams?: { returnTo?: string } }) => void,
  returnUrl?: string
): void => {
  // Clear all auth data from localStorage
  clearAuthData();

  // Logout from Auth0 and redirect to login page with logout state
  const logoutUrl = returnUrl || `${window.location.origin}/login?loggedOut=true`;

  auth0Logout({
    logoutParams: {
      returnTo: logoutUrl,
    },
  });
};
